<!-- Header -->
<header class="dashboard-header" [class]="'header-' + mode()">
  <div class="header-content">
    <div class="header-inner">
      <!-- Logo (always visible) -->
      <div class="header-left">
        <div class="logo-container" (click)="navigateToDashboard()" style="cursor: pointer;">
          <img
            src="/assets/images/logo.png"
            alt="Simpson Thacher"
            class="logo-image"
          />
        </div>

        <!-- Navigation (only when authenticated) -->
        @if (mode() === HeaderMode.AUTHENTICATED) {
        <nav class="nav-links">
          @if (hasAnyDashboardPermission) {
          <a routerLink="/dashboard" routerLinkActive="active" class="nav-link"
            >Dashboard</a
          >
          }
          @if (isClientsMattersEnabled && canViewClientMatters) {
          <a
            routerLink="/clients-matters"
            routerLinkActive="active"
            class="nav-link"
            >Clients & Matters</a
          >
          } @if (isResourcesEnabled && canViewResources) {
          <a routerLink="/resources" routerLinkActive="active" class="nav-link"
            >Resources</a
          >
          } @if (isRequestsEnabled && canViewRequests) {
          <a routerLink="/requests" routerLinkActive="active" class="nav-link"
            >Requests</a
          >
          } @if (canViewUsersManagement || canViewPracticeAreasManagement ||
          canViewFeatureFlagManagement) {
          <a routerLink="/admin" routerLinkActive="active" class="nav-link"
            >Admin</a
          >
          }
        </nav>
        }
      </div>

      <!-- User Profile (only when authenticated) -->
      @if (mode() === HeaderMode.AUTHENTICATED) {
      <div class="header-right">
        @if (isNotificationsEnabled) {
        <div class="notification-container">
          <button class="notification-bell" [class.jingle]="isJingling" aria-label="Notifications" (click)="toggleNotificationPanel($event)">
            <i class="material-symbols-outlined">notifications</i>
            @if (notificationCount > 0) {
              <span class="notification-badge">{{ notificationCount > 99 ? '99+' : notificationCount }}</span>
            }
          </button>

          <!-- Notification Panel -->
          <div class="notification-panel" [class.show]="isNotificationPanelOpen">
            <div class="notification-panel-arrow"></div>
            <div class="notification-panel-header">
              <span class="notification-panel-title">Notifications</span>
            </div>
            <div class="notification-panel-body">
              @if (notifications.length === 0) {
                <div class="notification-empty">No notifications at this time</div>
              } @else {
                @for (notification of notifications.slice(0, HEADER_NOTIFICATION_MAX_COUNT); track notification.id) {
                  <div class="notification-item" [class.unread]="!notification.isRead">
                    <div class="notification-item-content">
                      <div class="notification-item-header">
                        <span class="notification-item-title">{{ notification.title }}</span>
                        <span class="notification-item-time">{{ notification.createdAt | date:'MMM d, y h:mm a' }}</span>
                      </div>
                      <span class="notification-item-message" [innerHTML]="getDisplayMessage(notification)" (click)="onNotificationMessageClick($event, notification)"></span>
                    </div>
                  </div>
                }
              }
            </div>
            <div class="notification-panel-footer">
              <a class="notification-view-all" (click)="viewAllNotifications()">View All Notifications</a>
            </div>
          </div>
        </div>
        }
        <div
          class="user-profile"
          [class.open]="isDropdownOpen"
          (click)="toggleDropdown($event)"
        >
          <div class="user-avatar">
            <i class="material-symbols-outlined icon-sm">account_circle</i>
          </div>
          <span class="user-name">{{ currentUser }}</span>
          <i class="material-symbols-outlined dropdown-icon">keyboard_arrow_down</i>

          <!-- Dropdown Menu -->
          <div
            class="user-dropdown"
            [class.show]="isDropdownOpen"
            (click)="$event.stopPropagation()"
          >
            <div class="dropdown-header">
              <div class="dropdown-user-name">{{ currentUser }}</div>
              <div class="dropdown-user-email">{{ userEmail }}</div>
            </div>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="navigateToUserProfile()">
                <i class="material-symbols-outlined icon-sm">person</i>
                <span>User Profile</span>
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item danger" (click)="signOut()">
                <i class="material-symbols-outlined icon-sm">logout</i>
                <span>Sign Out</span>
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item dropdown-version-item" (click)="openReleaseNotes()">
                <span [class.whats-new-label]="isNewVersion" [class.text-muted]="!isNewVersion">
                  v{{ appVersion }} - {{ isNewVersion ? 'What\'s New' : 'Release Notes' }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</header>
